jQuery(document).ready(function ($) {

  /*
  Fancybox Setting
  https://fancyapps.com/fancybox/3/docs/#options
   */
  $.fancybox.defaults.animationEffect = "zoom";
  $.fancybox.defaults.transitionEffect = "fade";
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.closeExisting = true;
  $.fancybox.defaults.modal = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.buttons = [
    // "zoom",
    // "share",
    // "slideShow",
    //"fullScreen",
    //"download",
    // "thumbs",
    // "close"
  ];

  /* --------------- Topmenu Submenu Start */

  let hideTO = null;

  /**
   * Эвент наведения мыши на пункт меню
   */
  $("#siteshell").on('mouseover', 'ul.topmenu > li', function () {
    clearHideTo()
      .then(() => {
        // Убираем отображение других субменю
        const cur_index = $("#topmenu > ul.menu > li").index($(this));

        $("#topmenu").find('li').each((ind, obj) => {
          const work_idx = $("#topmenu > ul.menu > li").index($(obj));
          if (cur_index !== work_idx) {
            // console.log('work_idx', work_idx);
            // removeMenuProcedure(obj);
            $(obj).removeClass('submenu_visible').removeClass('submenu_display');
          }
        });
      })
      .then(() => {
        $(this).addClass('submenu_visible');
        setTimeout(() => {
          $(this).addClass('submenu_display');
        }, 50);
      });
  });

  /**
   * Евент увода мыши с пункта меню
   */
  $("#siteshell").on('mouseout', 'ul.topmenu > li', function () {
    hideSubMenu(this);
  });

  /**
   * Технологическая функция стирания setTomeout
   * @returns {Promise<void>}
   */
  function clearHideTo() {
    if (!!hideTO) {
      clearTimeout(hideTO);
    }
    return Promise.resolve();
  }

  /**
   * Исчезновение субменю при уводе курсора с субменю
   * @param obj
   */
  function hideSubMenu(obj) {
    clearHideTo()
      .then(() => {
        hideTO = setTimeout(() => removeMenuProcedure(obj), 100);
      });
  }

  /**
   * Процедура исчезновения Субменю
   * @param obj
   */
  function removeMenuProcedure(obj) {
    $(obj).removeClass('submenu_display');
    setTimeout(() => {
      $(obj).removeClass('submenu_visible');
    }, 250);
  }

  /* -------------- Topmenu Submenu End */

  /* --------------- POPUP Video ------ */


  // Закрыть

  $("#siteshell").on('click tap', "#yt-pu-close-icon, #yt-popup", (e) => {

    const targ_object = e.target;
    const closests = targ_object.closest('#yt-pu-content');

    if (!!closests) return false;

    $("#yt-pu-content").html("");

    $("#yt-popup").removeClass("show");
    setTimeout(() => {
      $("#yt-popup").removeClass("visible");
    }, 250);

    return false;
  });


  // ------------ Events

  const yt_link_objects = $("#siteshell").find('a.yt-play-video');

  yt_link_objects.each((ind, obj) => {
    const video_id = $(obj).attr('data-video');
    $(obj).on('click tap', () => {
      startPlayVideo(video_id);
    });
  });


  function startPlayVideo(video_id) {

    const iframe_html = `<iframe src="https://www.youtube.com/embed/${video_id}" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture;" allowfullscreen></iframe>`;

    $("#yt-pu-content").html(iframe_html);

    $("#yt-popup").addClass("visible");
    setTimeout(() => {
      $("#yt-popup").addClass("show");
    }, 50);
  }

  // Кнопка в хидере, направленная вниз.
  // При нажатии переход к следующему блоку / слою

  $("#siteshell").on("click tap", "#header_bottom_arrow_pos", function () {
    // const pos = $("main").offset().top - 90;
    const pos = $("main").offset().top;
    $("html, body").animate({
      'scrollTop': pos
    }, 1000, 'easeOutCubic');
  });

  /* ************ RESIZE ********** */

  $(window).on('load resize', win_resize);


  function win_resize() {
    check_is_mobile();

// .................
    // Дальнейшие действия при ресайзах  */

  }

  /* ***** набрасывание мобильного класса на окно */
  const mobile_limit = 1140;

  function check_is_mobile() {
    const w_width = $(window).width();
    const is_win_mobile = $("#siteshell").hasClass('mobile_version');

    if (is_win_mobile && (w_width > mobile_limit)) {
      if (tech_mobile) {
        set_mobile_win();
      } else {
        set_desctop_win();
      }
    } else if (!is_win_mobile && (w_width < mobile_limit)) {
      set_mobile_win();
    }
  }

  function set_mobile_win() {
    $("#siteshell").removeClass('desktop_version').addClass('mobile_version');
    $("#stick_menu").removeClass('stick_menu_displayed');
  }

  function set_desctop_win() {
    $("#siteshell").removeClass('mobile_version').addClass('desktop_version');
  }


});


//   T E L   Maska  
// let phoneInput = document.querySelectorAll('input[type="tel"]');
// phoneInput.forEach((item)=>{
//   item.setAttribute('maxlength','18');
//   item.addEventListener('input',()=>{
//     let filter = /\+{0,1}\d{0,}\({0,1}\d{0,}\){0,1}\-{0,1}\d{0,}\-{0,1}\d{0,}\-{0,1}\d{0,}/;
//     let str = item.value.match(filter);
//     item.value = str;
//   });
// });

